import React, { Suspense } from 'react';
import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';
import { isCorona, isConversation } from '../clearstep/util/AppHelpers';
import '../clearstep/proto/conversation_pb';
import { THEME } from '../clearstep/util/Theme';
import { MessageType, logEvent } from '../../util/EventLog';
import Button from './Button';
import { UTMContext, addParams } from '../../util/UTM';
import { RightArrow } from '../svg/Arrows';
import PartnerLogo from '../tailwind_clearstep/PartnerLogo/PartnerLogo';
import LanguageDropdown from '../tailwind_clearstep/LanguageDropdown/LanguageDropdown';
function showSwitchProduct() {
    return !THEME.symptomCheckOnly && !THEME.hideSwitchProduct;
}
var AppHeader = function (props) {
    var applyBottomBorder = props.applyBottomBorder, conversationType = props.conversationType, className = props.className;
    var t = useTranslation().t;
    var getSwitchProductCta = isCorona(props.complaint)
        ? t('switchProductCta.nonCovid', 'Check non-COVID symptoms')
        : t('switchProductCta.covid', 'Have a concern related to COVID? Click here');
    var switchProduct = function (url) {
        logEvent(MessageType.CLICKED_CONVO_HEADER, {
            name: getSwitchProductCta,
        }, { partner: THEME.partner });
        window.location.href = url;
    };
    var userId = window.externalUserId;
    var maybeUserId = userId ? { user_id: String(userId) } : undefined;
    var otherProduct = new URL(isCorona(props.complaint) ? '/checksymptoms/corona_funnel' : '/conversation/new/covid-19', window.location.href).toString();
    return (React.createElement(Suspense, { fallback: "" },
        React.createElement("div", { className: "sticky top-0 z-10" },
            React.createElement("header", { className: "top-0 w-full" },
                React.createElement("div", { className: twMerge('app-header-height', 'flex h-15 w-full flex-row items-center justify-between bg-white text-primary', applyBottomBorder && 'border-b border-solid border-common-ui-light-gray', className) },
                    React.createElement(PartnerLogo, { enableLogoLink: true }),
                    React.createElement(UTMContext.Consumer, null, function (utmParams) {
                        var doSwitch = function () {
                            return switchProduct(addParams(otherProduct, utmParams, {}, maybeUserId));
                        };
                        if (isConversation(conversationType) && showSwitchProduct()) {
                            return (React.createElement("div", { className: "mr-2 sm:mr-4" },
                                React.createElement(Button, { onClick: doSwitch, className: "rounded-none bg-transparent text-primary hover:underline", innerClassName: "flex flex-row items-center", styledText: true },
                                    getSwitchProductCta,
                                    React.createElement("div", { className: "ml-1.5" },
                                        React.createElement(RightArrow, null)))));
                        }
                        return null;
                    }),
                    React.createElement(LanguageDropdown, { conversationType: conversationType }))))));
};
export default AppHeader;
